import { render, staticRenderFns } from "./SlideMenuItem.vue?vue&type=template&id=340bec10&scoped=true&"
import script from "./SlideMenuItem.vue?vue&type=script&lang=js&"
export * from "./SlideMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./SlideMenuItem.vue?vue&type=style&index=0&id=340bec10&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340bec10",
  null
  
)

export default component.exports